export interface SimilarMovie {
  title: string;
  year: string;
  creator: string;
  desc: string;
  tags: string[];
  image: string;
}

export const similarFilterTags: string[] = ['全部', '同类题材', '都市爱情', '文艺剧情', '香港经典'];

export const similarMovies: SimilarMovie[] = [
  {
    title: '卿本佳人',
    year: '1991',
    creator: '主演 叶玉卿',
    desc: '同期都市题材港片，以都市男女关系为背景，是九十年代初颇具话题性的作品之一，气质上与「蜜桃」系列的都市情欲基调相近。',
    tags: ['同类题材', '都市爱情'],
    image:
      'https://readdy.ai/api/search-image?query=Elegant%201990s%20Hong%20Kong%20night%20street%20with%20warm%20neon%20glow%2C%20dreamy%20nostalgic%20mood%2C%20portrait%20composition%2C%20film%20grain&width=600&height=800&seq=peach-sim-02&orientation=portrait',
  },
  {
    title: '我为卿狂',
    year: '1991',
    creator: '主演 叶玉卿',
    desc: '同属都市情欲题材的年代作品，聚焦成年男女之间的情感拉扯，可与《蜜桃成熟时》对照观看，感受同一时期的题材风貌。',
    tags: ['同类题材', '都市爱情'],
    image:
      'https://readdy.ai/api/search-image?query=Warm%20art%20deco%20interior%20with%20soft%20lamp%20light%2C%20vintage%201990s%20atmosphere%2C%20amber%20and%20terracotta%20tones%2C%20portrait%20composition&width=600&height=800&seq=peach-sim-03&orientation=portrait',
  },
  {
    title: '色情男女',
    year: '1996',
    creator: '导演 尔冬升 · 主演 张国荣、莫文蔚、舒淇',
    desc: '以电影行业为背景的剧情片，曾获香港电影金像奖多项肯定。虽然取向更偏文艺，但同样直视九十年代香港影视生态，是理解该题材时代语境的佳作。',
    tags: ['同类题材', '文艺剧情'],
    image:
      'https://readdy.ai/api/search-image?query=Moody%20film%20set%20with%20vintage%20camera%20and%20warm%20spotlight%2C%20retro%20cinema%20atmosphere%2C%20warm%20amber%20palette%2C%20portrait%20composition&width=600&height=800&seq=peach-sim-01&orientation=portrait',
  },
  {
    title: '甜蜜蜜',
    year: '1996',
    creator: '导演 陈可辛 · 主演 黎明、张曼玉',
    desc: '九十年代华语爱情经典，用一对异乡男女的聚散书写时代变迁。若你喜欢《蜜桃成熟时》里「出走与相遇」的爱情线，这部会让你看到更细腻的版本。',
    tags: ['都市爱情', '香港经典'],
    image:
      'https://readdy.ai/api/search-image?query=Bicycle%20leaning%20on%20a%20warm%20rainy%20evening%20street%2C%20romantic%201990s%20Hong%20Kong%20mood%2C%20amber%20glow%2C%20portrait%20composition&width=600&height=800&seq=peach-sim-04&orientation=portrait',
  },
  {
    title: '阿飞正传',
    year: '1990',
    creator: '导演 王家卫 · 主演 张国荣、张曼玉',
    desc: '港产文艺片的里程碑，围绕孤独、自由与漂泊展开。与《蜜桃成熟时》一样关注都市中的情感游离，但表达方式更为作者化、更具氛围感。',
    tags: ['文艺剧情', '香港经典'],
    image:
      'https://readdy.ai/api/search-image?query=Tropical%20palm%20leaves%20in%20warm%20afternoon%20light%2C%20nostalgic%20film%20mood%2C%20golden%20and%20peach%20tones%2C%20portrait%20composition&width=600&height=800&seq=peach-sim-05&orientation=portrait',
  },
  {
    title: '重庆森林',
    year: '1994',
    creator: '导演 王家卫 · 主演 梁朝伟、王菲',
    desc: '都市爱情题材的代表作，把都市人的疏离与偶然相遇拍得灵动轻巧。喜欢九十年代港片氛围与爱情叙事的观众，几乎不会错过这一部。',
    tags: ['都市爱情', '香港经典'],
    image:
      'https://readdy.ai/api/search-image?query=Colorful%20tiled%20corridor%20with%20warm%20light%2C%20urban%20nostalgic%20mood%2C%20retro%20film%20texture%2C%20portrait%20composition&width=600&height=800&seq=peach-sim-06&orientation=portrait',
  },
];